export const ERROR__MESSAGES = {
  WRONG_PHONE_NUMBER: "شماره همراه اشتباه است",
  INVALID_OTP: "کد تایید نامعتبر است",
  POSTAL_CODE_NOT_FOUND: "کد پستی معتبر نیست",
  INVALID_POSTAL_CODE: "کد پستی معتبر نیست",
  PHONE_NUMBER_AND_NATIONAL_CODE_MISMATCH: "شماره همراه و کد ملی مطابقت ندارند",
  PHONE_NUMBER_IN_USE: "شماره همراه قبلا ثبت شده است.",
  BIRTH_DATE_NOT_VALID: "تاریخ تولد معتبر نیست",
  INVALID_SHEBA: "شماره شبا معتبر نیست",
  INVALID_CARD_NUMBER: "شماره کارت معتبر نیست",
  SHEBA_NATIONAL_CODE_MISMATCH: "کد ملی و شماره شبا مطابقت ندارند",
  CARD_NATIONAL_CODE_MISMATCH: "کد ملی و شماره کارت مطابقت ندارند",
  INVALID_VERIFICATION_CODE: "کد تایید نامعتبر است",
  "An active OTP already exists for this type.": "کد تایید فعالی برای این نوع وجود دارد. لطفاً از کد قبلی استفاده کنید.",
};
